// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JnSMD","isOnTv":"styles_isOnTv__CfZ9U","isOnMobil":"styles_isOnMobil__SP0Qv","marginIcon":"styles_marginIcon__a-4Oz","wrap":"styles_wrap__CsKhx"};